import { ProfileSettingsAvatarDialog } from './profile-settings-avatar-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PROFILE_SETTINGS_AVATAR, {
  component: ProfileSettingsAvatarDialog,
  transition: transitions.FULL_SCREEN,
  anchor: 'portal',
});
